import React from 'react';
import Header from './components/Header';
import Prismic from '@prismicio/client'
import './App.css';
import BlueLine from './components/BlueLine';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Banner from './components/Banner';
import Footer from './components/Footer';
import About from './components/About';
import Publications from './components/Publications';
import Research from './components/Research';
import VisitingScholars from './components/VisitingScholars';
import GraduateStudents from './components/GraduateStudents';
import NewsItem from './components/NewsItem';
import ProfessionalActivities from './components/ProfessionalActivities';
import Honors from './components/Honors';

const apiEndpoint = 'https://smithae.prismic.io/api/v2'
const accessToken = '' // This is where you would add your access token for a Private repository
const client = Prismic.client(apiEndpoint, { accessToken })

function RedirectSmithaeToAesmith() {
  const location = useLocation();
  const newPath = location.pathname.replace('/~smithae', '/~aesmith');
  return <Redirect to={newPath} />;
}

function App() {

  return (
    <div className="App">
      <Header />
      <BlueLine />
      <Banner />
      <BlueLine />
      <div className="Content">
          <Switch>
          <Route path="/~smithae">
            <RedirectSmithaeToAesmith />
          </Route>
          <Route path="/~aesmith/research" exact={true}>
            <Research client={client} />
          </Route>
          <Route path="/~aesmith/honors" exact={true}>
            <Honors client={client} />
          </Route>
          <Route path="/~aesmith/professional-activities" exact={true}>
            <ProfessionalActivities client={client} />
          </Route>
          <Route path="/~aesmith/visiting-scholars" exact={true}>
            <VisitingScholars client={client} />
          </Route>
          <Route path="/~aesmith/graduate-students" exact={true}>
            <GraduateStudents client={client} />
          </Route>
          <Route path="/~aesmith/publications" exact={true}>
            <Publications client={client} />
          </Route>
          <Route path="/~aesmith/news-item" exact={true}>
            <NewsItem client={client} />
          </Route>
          <Route path="/~aesmith/" exact={true}>
            <About client={client} />
          </Route>
        </Switch>
      </div>

      <Footer />
    </div>
  );
}

export default App;
